/**
 * 모든 커스텀 에러의 기본 클래스
 */
export abstract class BaseError extends Error {
  declare cause?: unknown;

  constructor(message: string, cause?: unknown) {
    super(message, { cause });

    // cause를 지원하지 않는 구형 브라우저 대응
    if (cause && !this.cause) {
      this.cause = cause;
    }
  }
}
